import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=77c398be&scoped=true"
import script from "./TestimonialCard.js?vue&type=script&lang=js&external"
export * from "./TestimonialCard.js?vue&type=script&lang=js&external"
import style0 from "./TestimonialCard.scss?vue&type=style&index=0&id=77c398be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c398be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HotHcmAvatar: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/HcmAvatar/index.vue').default,HotHcmCard: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmCard/index.vue').default})
